module.exports = __webpack_public_path__ + "img/index_part6img.220ab53a.jpg";